import "./init";

import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";

import "./index.css";

import App from "./App";
import { store } from "./store";
import { getDeviceInfo } from "./utils/helpers";

const COMMIT_ID = process.env.VITE_GIT_COMMIT_HASH || "development";
const BUILD_TIME = process.env.VITE_BUILD_TIME || new Date().toISOString();

// Log them to console for easy verification
console.log(
  `%c App Version %c ${COMMIT_ID.substring(0, 7)} %c ${new Date(BUILD_TIME).toLocaleString()} `,
  "background: #333; color: white; padding: 2px;",
  "background: #007700; color: white; padding: 2px;",
  "background: #0055aa; color: white; padding: 2px;",
);

const deviceInfo = getDeviceInfo();
console.log(
  `OS: ${deviceInfo.os}, Platform: ${deviceInfo.platform}, Browser: ${deviceInfo.name}, Version: ${deviceInfo.version}`,
);

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById("root"),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
